import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; // Optional for alerts

const GlobalBrandAdd = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    image: null,
    logo: null,
    discount: '',
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, [field]: file }));
      if (field === 'image') setPreviewImage(URL.createObjectURL(file));
      if (field === 'logo') setPreviewLogo(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.image || !formData.logo || !formData.discount) {
      alert('All fields are required');
      return;
    }

    try {
      setLoading(true);

      // Prepare multipart form data
      const data = new FormData();
      data.append("global_brand_image", formData.image);
      data.append("brand_logo", formData.logo);
      data.append("discount", formData.discount);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_global_brand",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        toast.success("Brand added successfully!");
        navigate("/GlobalBrand"); // redirect back to list page
      } else {
        toast.error(response.data.message || "Failed to add brand");
      }
    } catch (error) {
      console.error("Error adding brand:", error);
      toast.error("Something went wrong while adding the brand");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Add Global Brand</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Global Brand</a></li>
            <li className="breadcrumb-item active">Add</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">New Global Brand</h4>
            </div>
            <div className="card-body row">
              <div className="col-lg-6 mb-3">
                <label className="form-label">Main Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'image')}
                />
                {previewImage && <img src={previewImage} alt="Preview" height="80" className="mt-2" />}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Brand Logo</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'logo')}
                />
                {previewLogo && <img src={previewLogo} alt="Logo" height="80" className="mt-2" />}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Discount</label>
                <input
                  type="text"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g., 50% Off"
                  required
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Saving..." : "Save Global Brand"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GlobalBrandAdd;
